import * as types from '../constants'

const initialState = {
  currentIp: '',
  currentUser: {},
}

const user = (state = initialState, action) => {
  switch (action.type) {

    case types.UPDATE_USER:
      return { ...state, currentUser: action.payload }

    case types.UPDATE_IP:
      return { ...state, currentIp: action.payload }

    default:
      return state
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/user/reducer.js